import { AnalyticsClientUpdater } from "../../components/analytics-client-updater";
import { TenantAwareStatsigClientUpdaterProvider } from "../../hooks/use-tenant-aware-statsig-client-updater";
import { PerceivedProvisioningStartTimer } from "../../utils/perceived-provisioning/perceived-provisioning-start-timer";
import { jiraScreenConfig } from "../../utils/screen-manager/jira-screen-config";
import { jiraScreenDictionary } from "../../utils/screen-manager/jira-screen-dictionary";
import { JiraAnimatedProvisioningScreen } from "../jira-animated-provisioning-screen/jira-animated-provisioning-screen";
import { ProductRedirector } from "../product-redirector/product-redirector";

import { BaseProvisioningUI } from "./base-provisioning-ui";

/**
 * Component that shows provisioning UI for Jira.
 * @returns @type {JSX.Element}
 */
export const JiraProvisioningUI = () => (
    <TenantAwareStatsigClientUpdaterProvider>
        <AnalyticsClientUpdater />
        <BaseProvisioningUI
            screenConfig={jiraScreenConfig}
            screenDictionary={jiraScreenDictionary}
            screenFallback={
                <PerceivedProvisioningStartTimer>
                    <ProductRedirector>
                        <JiraAnimatedProvisioningScreen />
                    </ProductRedirector>
                </PerceivedProvisioningStartTimer>
            }
        />
    </TenantAwareStatsigClientUpdaterProvider>
);
